import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from "react";
import "./SelectUsers.scss";
import { IoSearchOutline, IoCloseCircleOutline } from "react-icons/io5";
import RestClient from "../../../@core/restClient";
import debounce from "lodash/debounce";
import Spinner from "../UI/Spinner";

const SelectUsers = (
  { passingCollaboratorsArray, editMode, collaboratorsList }: any,
  ref: any
) => {
  const [userList, setUserList]: any = useState([]);
  const [selectVisible, setSelectVisible]: any = useState("");
  const [inputValue, setInputValue]: any = useState("");
  const [selectedUsers, setSelectedUsers]: any = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const emailRef = useRef<any>();

  useEffect(
    function () {
      if (editMode === true) setSelectedUsers(collaboratorsList);
    },
    [editMode]
  );

  useImperativeHandle(ref, () => ({
    emptyCollaboratorsArray: () => {
      setSelectedUsers([]);
      if (emailRef.current.value) emailRef.current.value = "";
    }
  }));

  const deferredSetQueryHandler = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target?.value.length > 2) {
        setInputValue(event.target?.value);
      } else if (event.target?.value === "") {
        setSelectVisible(false);
        setInputValue("");
      }
    }, 200),
    []
  );

  useEffect(
    function () {
      (async () => {
        try {
          if (inputValue === "") {
            return;
          } else {
            setIsLoading(true);
            const list = await RestClient.getUsers(inputValue);
            setUserList(list || []);
            setSelectVisible("visable");
            setIsLoading(false);
          }
        } catch (error) {
          console.log(error);
        }
      })();
    },
    [inputValue]
  );

  const selectUser = (user: any, e: any) => {
    e.stopPropagation();
    setInputValue("");
    setSelectVisible("");
    const selectedUser = {
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName
    };
    setSelectedUsers([...selectedUsers, selectedUser]);
    if (emailRef.current.value) emailRef.current.value = "";
  };

  useEffect(() => {
    if (!selectVisible) return;

    const handleBodyClick = () => {
      setSelectVisible(false);
      setInputValue("");
      if (emailRef.current.value) emailRef.current.value = "";
    };

    document.body.addEventListener("click", handleBodyClick);

    return () => {
      document.body.removeEventListener("click", handleBodyClick);
    };
  }, [selectVisible]);

  const deleteUser = (user: any) => {
    const newSelectedUsers = selectedUsers.filter((item: any) => item !== user);
    setSelectedUsers(newSelectedUsers);
  };

  useEffect(
    function () {
      try {
        passingCollaboratorsArray([...new Set(selectedUsers)]);
      } catch (error) {
        console.log(error);
      }
    },
    [selectedUsers]
  );

  return (
    <div className="select">
      {isLoading ? <Spinner /> : ""}
      <input
        className="select-input"
        ref={emailRef}
        // value={inputValue}
        onChange={deferredSetQueryHandler}
      />
      <div className={selectVisible || "select-box"}>
        {userList.map((user: any, i: any) => (
          <div
            key={i}
            className="select-box-item"
            onClick={(e) => selectUser(user, e)}
          >
            {user.firstName} {user.lastName}{" "}
            <span className="user-email">{user.email}</span>{" "}
          </div>
        ))}
        {userList.length > 0 ? (
          ""
        ) : (
          <p className="select-box-message">Не знайдено</p>
        )}
      </div>
      <IoSearchOutline className="select-search" />
      <div className="added">
        {selectedUsers.map((person: any, i: any) => (
          <div className="added-sb-user" key={i}>
            {person.firstName} {person.lastName}
            <IoCloseCircleOutline
              className="added-sb-user-icon"
              onClick={() => deleteUser(person)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default forwardRef(SelectUsers);
